export let juneUppercase = "imx5l";
export default {juneUppercase};